import request from '@/utils/request'

// 默认供应商类型常量
export const TARGET_TYPES = [
  { value: 'jin_jiang', label: '锦江', tagType: 'primary' },
  { value: 'long_teng', label: '龙腾', tagType: 'warning' },
  { value: 'sui_chuan', label: '隧穿', tagType: 'success' },
  { value: 'li_cheng', label: '丽呈', tagType: 'warning' },
]

// 缓存数据
let cachedData = null

/**
 * 获取供应商类型列表
 * 优先使用缓存 > localStorage > 默认值
 */
export function getTargetTypes() {
  if (cachedData) return cachedData

  const cached = localStorage.getItem('target_types')
  if (cached) {
    cachedData = JSON.parse(cached)
    return cachedData
  }

  return TARGET_TYPES
}

/**
 * 从接口获取并缓存供应商类型
 */
export async function fetchTargetTypes() {
  try {
    const res = await request({
      url: '/api/backend/target-type/list',
      method: 'get',
    })
    if (res.data && res.data.length > 0) {
      cachedData = res.data
      localStorage.setItem('target_types', JSON.stringify(res.data))
      return res.data
    }
  } catch (e) {
    console.warn('获取供应商类型失败，使用缓存')
  }
  return getTargetTypes()
}

/**
 * 根据 value 获取名称
 */
export function getTargetTypeName(value) {
  const types = getTargetTypes()
  const found = types.find((item) => item.value === value)
  if (found && found.label) return found.label
  return DEFAULT_LABEL_MAP[value] || value || '-'
}

// 默认名称映射
const DEFAULT_LABEL_MAP = {
  jin_jiang: '锦江',
  long_teng: '龙腾',
  sui_chuan: '隧穿',
  li_cheng: '丽呈',
}

// 默认标签类型映射
const DEFAULT_TAG_TYPE_MAP = {
  jin_jiang: 'primary',
  long_teng: 'warning',
  sui_chuan: 'success',
  li_cheng: 'warning',
}

/**
 * 根据 value 获取标签类型
 */
export function getTargetTypeTagType(value) {
  const types = getTargetTypes()
  const found = types.find((item) => item.value === value)
  if (found && found.tagType) return found.tagType
  return DEFAULT_TAG_TYPE_MAP[value] || 'info'
}

/**
 * 清空缓存（用于调试或强制刷新）
 */
export function clearTargetTypeCache() {
  cachedData = null
  localStorage.removeItem('target_types')
}
